import { render, staticRenderFns } from "./MyOrdersResearcher.vue?vue&type=template&id=78e0496e&scoped=true"
import script from "./MyOrdersResearcher.vue?vue&type=script&lang=js"
export * from "./MyOrdersResearcher.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersResearcher.vue?vue&type=style&index=0&id=78e0496e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0496e",
  null
  
)

export default component.exports